<div class="container-fluid main_container no-opac">
  <app-menu></app-menu>
  <div class="router-wrapper"  [@routeAnimations]="outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation']" >
    <router-outlet  #outlet="outlet"></router-outlet>
  </div>
  <div>
    <app-footer></app-footer>
  </div>
</div>
